import React from 'react'

import { Placeholder, Typography } from '@s4l/ds'
import { useS4LContext } from '@s4l/react-context'
import { useUseCase } from '@s4l/utils/hooks/useUseCase'
import type { Money } from '@s4l/stayforlong/kernel/Money'
import { PriceType } from '@s4l/stayforlong/kernel/PriceType'

interface PriceDiffProps {
  diff: { total: Money; perNight: Money } | null
}

function PriceDiff({ diff }: Readonly<PriceDiffProps>) {
  const { i18n } = useS4LContext()

  const {
    data: market,
    loading: loadingMarket,
    error: errorMarket,
  } = useUseCase('GetCurrentMarketSharedUseCase')
  const {
    data: affiliate,
    loading: isLoadingAffiliate,
    error: errorAffiliate,
  } = useUseCase('GetCurrentAffiliateSharedUseCase')

  if (!diff) return null
  if (loadingMarket || isLoadingAffiliate) return <Placeholder width="150px" height="24px" />
  if (errorMarket || !market) return null
  if (errorAffiliate || !affiliate) return null

  const priceType = PriceType.fromAffiliatePriceType({
    affiliate,
    market,
  })
  const kindFeaturedPrice = priceType.isFeaturedPriceTotal() ? 'total' : 'perNight'

  const price = diff[kindFeaturedPrice]

  const sign = price.isPositive() ? '+' : ''

  return (
    <Typography variant="caption" size="l" as="span" bold>
      {sign}
      {price.toFormattedString(i18n.locale, market)}
    </Typography>
  )
}

PriceDiff.displayName = 'PriceDiff'

export default PriceDiff
